import { lazy } from "react";
import { Navigate, useParams } from "react-router-dom";

const Home = lazy(() => import("../pages/home/page"));
// const WMS = lazy(() => import("../pages/wms/_page"));
const WMSEcommerce = lazy(() => import("../pages/wms/ecommerce/page"));
const WMS3PL = lazy(() => import("../pages/wms/3pl/page"));
const TMS = lazy(() => import("../pages/tms/page"));
const ERP = lazy(() => import("../pages/erp/page"));
const ERPCaseStudies = lazy(() => import("../pages/erp/case-studies/page"));
const ERPTourBusCaseStudy = lazy(
  () => import("../pages/erp/case-studies/tour-bus/page")
);
const ERPOfferMockup = lazy(() => import("../pages/erp-offer-mockup/page"));
const AddressStandardization = lazy(
  () => import("../pages/tms/address-standardization/page")
);
const WMSTMSSelectionGuide = lazy(
  () => import("../pages/wms-tms-selection-guide/page")
);
const HongKongWMSSystem = lazy(
  () => import("../pages/hong-kong-wms-system/page")
);
const TPLSP = lazy(() => import("../pages/tplsp/page"));
const About = lazy(() => import("../pages/about/page"));
const Blog = lazy(() => import("../pages/blogs/page"));
const BlogArticle = lazy(() => import("../pages/blogs/[slug]/page"));
const Insights = lazy(() => import("../pages/insights/page"));
const InsightArticle = lazy(() => import("../pages/insights/[slug]/page"));
const Privacy = lazy(() => import("../pages/privacy/page"));
const DeleteAccount = lazy(() => import("../pages/delete-account/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

function LegacyKnowledgeArticleRedirect() {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={slug ? `/knowledge/${slug}` : "/knowledge"} replace />;
}

const routes = [
  {
    path: "/",
    element: <Home />,
  },
  // {
  //   path: "/wms",
  //   element: <WMS />,
  // },
  {
    path: "/wms/ecommerce",
    element: <WMSEcommerce />,
  },
  {
    path: "/wms/3pl",
    element: <WMS3PL />,
  },
  {
    path: "/tms",
    element: <TMS />,
  },
  {
    path: "/erp",
    element: <ERP />,
  },
  {
    path: "/erp/case-studies",
    element: <ERPCaseStudies />,
  },
  {
    path: "/erp/case-studies/tour-bus",
    element: <ERPTourBusCaseStudy />,
  },
  {
    path: "/erp-offer-mockup",
    element: <ERPOfferMockup />,
  },
  {
    path: "/tms/address-standardization",
    element: <AddressStandardization />,
  },
  {
    path: "/wms-tms-selection-guide",
    element: <WMSTMSSelectionGuide />,
  },
  {
    path: "/hong-kong-wms-system",
    element: <HongKongWMSSystem />,
  },
  {
    path: "/tplsp",
    element: <TPLSP />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/knowledge",
    element: <Blog />,
  },
  {
    path: "/knowledge/:slug",
    element: <BlogArticle />,
  },
  {
    path: "/insights",
    element: <Insights />,
  },
  {
    path: "/insights/:slug",
    element: <InsightArticle />,
  },
  {
    path: "/blogs",
    element: <Navigate to="/knowledge" replace />,
  },
  {
    path: "/blogs/:slug",
    element: <LegacyKnowledgeArticleRedirect />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/delete-account",
    element: <DeleteAccount />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
